export default __webpack_public_path__ + "static/media/Experience_iResponsive_Vertical.7ec6fb86.png";